import React, { useContext, useEffect, useState } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { ShopContext } from '../../data/shop/ShopConf';
import DefaultStakes from './DefaultStakes';
import { getAmountInCent, getConfiguration, getCurrencySymbol, getCurrencyValue, getLocaleDotRound, getPrintableAmount, getValidAmountString, selectInputText } from '../../data/utils';
import { getLabel } from '../../InitData';

export default function AmountBetslipForm(props) {
	const betslipContext = useContext(BetslipContext) ;
	const shopContext = useContext(ShopContext);
	const betslipData = betslipContext.getBetslipData();
	const conf = getConfiguration();
	const mult = conf.cs.m;
	const nDec = conf.cs.nd;
	const charDecimalBrowser = getLocaleDotRound().round;
	const charThousandBrowser = getLocaleDotRound().dot;
    const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
   // the amount we use to make calcs
   const amount = coupon.selectedContainer === 'systembets'? coupon.amountSystem : coupon.amountMulti;
   // the amount printed in the text field
   const printableAmount =  coupon.selectedContainer === 'systembets'? coupon.printableAmountSystem : coupon.printableAmountMulti;

   
	function setAmountFromCalc(amountCalc) {
   		// if(amount !== betslipContext.minimumBetAmount){
   		// 	amountCalc += amount;
   		// }
		amountCalc = getPrintableAmount(amountCalc, mult, nDec);
		amountCalc = amountCalc.replaceAll(charThousandBrowser, ''); // remove the thousand char from the string. In the setAmount only "decimal" is permitted
		setAmount(amountCalc);
   }


	function setAmount(settedAmount) {
	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
		settedAmount = getValidAmountString(settedAmount, nDec);
	   	// putting the "browser decimal dot" instead of the "." used for the float type
	   	let fieldTextValue = settedAmount;
	   	fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
	   	let amountCentToSet = amount; // last valid amount
	   
	   // if is number, I calculate the new amount and I keep it into the field value. 
	   // If not, I keep the field but I use the last valid amount for the calcs
	   	if (isNaN(settedAmount) === false && settedAmount.length > 0) {
		   amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
	   	}
		betslipContext.setGeneralStake(amountCentToSet, null, fieldTextValue);
	}

    function handleKey(e) {
    	if (e.key === 'Enter' && coupon.selectedContainer !== 'systembets') {
			if (shopContext.enabled) {
				betslipContext.purchase();
			} else {
				if (betslipContext.getPlayButtonState() === 'play') {
					betslipContext.setPlayButtonState('confirm');
				} else if (betslipContext.getPlayButtonState() === 'confirm') {
					betslipContext.purchase();
				}		
			}
    	}
    }
   
    const betOptionsSelection = betslipContext.getBetOptionsSelection();
	const [wagerState, setWagerState] = useState(true);
	function removeWager(){
		setWagerState(false);
		// per far vedere l'animazione
		setTimeout(() => {
			betslipContext.setRealMoney();
		}, 500);
	}
	useEffect(() => {
		if(!betOptionsSelection || betOptionsSelection.value === 'REAL'){
			setWagerState(false);
		}
		else{
			setWagerState(true);
		}
	}, [betOptionsSelection, betOptionsSelection?.value])
    return (
        <>
            <DefaultStakes setAmountFromCalc={setAmountFromCalc} />
            <div className="b_12_3">
                {
                	coupon.selectedContainer !== 'systembets' && <div className="b_12_3_1">
                		{
                			betOptionsSelection?.value !== 'REAL' &&
	                		<label className="custom-switch-2">
	                			<span className="label-text"> {betOptionsSelection.type === 'freebet'? getLabel('mybets.freebet') : getLabel('mybets.funbonus')} </span>
	                			<input id="wageringToggle" type="checkbox" checked={wagerState} onChange={removeWager} />
	                			<span className="custom-slider-2 round" />
	                		</label>                		
                		}

                	</div>
                }
                <div className="b_12_3_2">
                    <span className="b_12_3_2_1">{getLabel('general.importo')}</span>
                    <div className="b_12_3_2_2">
                        <input type="text" 
                               className="b_12_3_2_2_1"
                               onFocus={selectInputText}
                               placeholder={getLabel('carrello.puntata')}
                               value={printableAmount}
                               onChange={e => setAmount(e.target.value + "")}
                               onKeyUp={e => handleKey(e)}
                        />
                        <span className="b_12_3_2_2_2">{getCurrencySymbol()}</span>
                    </div>
                </div>
                {coupon.selectedContainer === 'systembets' && 
	                 <div className="b_12_3_1">
	                	<span className="b_12_3_1_1">{getLabel('betslip.calculated_stake')?.toUpperCase()}</span>
	                	<span className="b_12_3_1_1">{getCurrencyValue(amount, mult, nDec, conf.cs.ct)}</span>
	                </div>
                }
            </div>
        </>
    );
}
